import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import CorridorDetail from "@/pages/CorridorDetail";
import Admin from "@/pages/Admin";
import { LeadModalProvider } from "@/context/LeadModalContext";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <LeadModalProvider>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/corridors/:slug" element={<CorridorDetail />} />
                        <Route path="/admin" element={<Admin />} />
                    </Routes>
                </LeadModalProvider>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                closeButton
                toastOptions={{
                    classNames: {
                        toast:
                            "!bg-zinc-950 !text-white !border !border-emerald-500/30 !shadow-2xl !rounded-2xl !backdrop-blur-xl",
                        title: "!font-heading !font-bold !text-base",
                        description: "!text-zinc-300 !text-sm",
                    },
                }}
            />
        </div>
    );
}

export default App;
